import React, { useState, useEffect } from 'react';
import './SubscriptionExpiredModal.scss';
import { FaCrown, FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext.js";
import { getCompanyDataByID } from "../../services/api/CompanyApi";
import PlanSelectionModal from '../PlanSelectionModal/PlanSelectionModal';


const SubscriptionExpiredModal = ({ isOpen, companyId, onUpgrade }) => {
  const navigate = useNavigate();
  const { logout} = useAuth();
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (isOpen && companyId) {
        setLoading(true);
        try {
          const response = await getCompanyDataByID(companyId);
          setCompanyData(response.data.company);
        } catch (error) {
          console.error("Error fetching company data:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCompanyData();
  }, [isOpen, companyId]);

  const isEnterprisePlan = companyData?.type === "ent";
  
  if (!isOpen) return null;
  
  const handleUpgrade = () => {
    if (companyId) {
      setIsPlanModalOpen(true);
    } else {
      console.error("Company ID not found");
    }
  };

  const handleLogout = () => {
    logout();
    // Delay navigation to allow state updates to complete
    setTimeout(() => {
      navigate("/");
    }, 0);
  };

  const handleSelectPlan = (selectedPlan, companyId) => {
    console.log('Selected Plan:', selectedPlan);
  };

  return (
    <>
      <div className="subscription-expired-modal-overlay">
        <div className="subscription-expired-modal">
          <div className="modal-header">
            <div className="warning-icon">
              <FaExclamationTriangle size={32} color="#ff6b35" />
            </div>
            <h2>Subscription Expired</h2>
          </div>
          
          <div className="modal-body">
            <div className="expired-message">
              {isEnterprisePlan ? (
                <p>
                  Your subscription period has ended. For Enterprise plan renewals or modifications, 
                  please contact our support team at{' '}
                  <a href="mailto:support@levons.in" style={{ color: 'var(--primary-color)', fontWeight: '600' }}>
                    support@levons.in
                  </a>
                </p>
              ) : (
                <p>Your subscription period has ended. To continue using all features of LawsuitPro, please renew your plan.</p>
              )}
            </div>
          </div>
          
          <div className="modal-footer">
            {!isEnterprisePlan && (
              <button 
                className="upgrade-button-primary"
                onClick={handleUpgrade}
              >
                <FaCrown size={16} />
                Renew Your Plan
              </button>
            )}
            <button className="logout-button-secondary" onClick={handleLogout}>
              Logout
            </button>
            {/* <p className="upgrade-note">
              Secure payment processing • Instant activation
            </p> */}
          </div>
        </div>
      </div>

      <PlanSelectionModal
        isOpen={isPlanModalOpen}
        companyId={companyId}
        onClose={() => setIsPlanModalOpen(false)}
        onSelectPlan={handleSelectPlan}
      />
    </>
  );
};

export default SubscriptionExpiredModal;